function toolsSearch() {
	const searchContainers = document.querySelectorAll('.search-container');

	searchContainers.forEach((searchContainer) => {
		const searchPanel = searchContainer.querySelector('.search-panel');
		if (!searchPanel) return;

		const isSearchPanelOpen = /** @type {ReactiveTuple<boolean>} */reactive(false);
		const searchTrigger = searchContainer.querySelector('button[data-action="search-trigger"]');

		isSearchPanelOpen.subscribe((newIsSearchPanelOpen) => {
			searchTrigger.ariaExpanded = newIsSearchPanelOpen;
		});

		// Search trigger
		searchPanel.addEventListener('keyup', (e) => {
			if (e.key === 'Escape') {
				isSearchPanelOpen.set(false);
			}
		});

		searchTrigger.addEventListener('click', () => {
			isSearchPanelOpen.set((currentIsOpen) => !currentIsOpen);
		});

		clickedOutside(searchPanel, () => {
			isSearchPanelOpen.set(false);
		}, [searchTrigger]);
	});
}